import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import paginate from 'jw-paginate';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = function (a0) { return { active: a0 }; };
function JwPaginationComponent_ul_0_li_7_Template(rf, ctx) { if (rf & 1) {
    const _r419 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵelementStart(1, "a", 3);
    ɵngcc0.ɵɵlistener("click", function JwPaginationComponent_ul_0_li_7_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r419); const page_r417 = ctx.$implicit; const ctx_r418 = ɵngcc0.ɵɵnextContext(2); return ctx_r418.setPage(page_r417); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const page_r417 = ctx.$implicit;
    const ctx_r416 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c0, ctx_r416.pager.currentPage === page_r417));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(page_r417);
} }
const _c1 = function (a0) { return { disabled: a0 }; };
function JwPaginationComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    const _r421 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 1);
    ɵngcc0.ɵɵelementStart(1, "li", 2);
    ɵngcc0.ɵɵelementStart(2, "a", 3);
    ɵngcc0.ɵɵlistener("click", function JwPaginationComponent_ul_0_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r421); const ctx_r420 = ɵngcc0.ɵɵnextContext(); return ctx_r420.setPage(1); });
    ɵngcc0.ɵɵtext(3, "First");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "li", 4);
    ɵngcc0.ɵɵelementStart(5, "a", 3);
    ɵngcc0.ɵɵlistener("click", function JwPaginationComponent_ul_0_Template_a_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r421); const ctx_r422 = ɵngcc0.ɵɵnextContext(); return ctx_r422.setPage(ctx_r422.pager.currentPage - 1); });
    ɵngcc0.ɵɵtext(6, "Previous");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, JwPaginationComponent_ul_0_li_7_Template, 3, 4, "li", 5);
    ɵngcc0.ɵɵelementStart(8, "li", 6);
    ɵngcc0.ɵɵelementStart(9, "a", 3);
    ɵngcc0.ɵɵlistener("click", function JwPaginationComponent_ul_0_Template_a_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r421); const ctx_r423 = ɵngcc0.ɵɵnextContext(); return ctx_r423.setPage(ctx_r423.pager.currentPage + 1); });
    ɵngcc0.ɵɵtext(10, "Next");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "li", 7);
    ɵngcc0.ɵɵelementStart(12, "a", 3);
    ɵngcc0.ɵɵlistener("click", function JwPaginationComponent_ul_0_Template_a_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r421); const ctx_r424 = ɵngcc0.ɵɵnextContext(); return ctx_r424.setPage(ctx_r424.pager.totalPages); });
    ɵngcc0.ɵɵtext(13, "Last");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r415 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c1, ctx_r415.pager.currentPage === 1));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c1, ctx_r415.pager.currentPage === 1));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r415.pager.pages);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c1, ctx_r415.pager.currentPage === ctx_r415.pager.totalPages));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c1, ctx_r415.pager.currentPage === ctx_r415.pager.totalPages));
} }
let JwPaginationComponent = class JwPaginationComponent {
    constructor() {
        this.changePage = new EventEmitter(true);
        this.initialPage = 1;
        this.pageSize = 10;
        this.maxPages = 10;
        this.pager = {};
    }
    ngOnInit() {
        // set page if items array isn't empty
        if (this.items && this.items.length) {
            this.setPage(this.initialPage);
        }
    }
    ngOnChanges(changes) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.setPage(this.initialPage);
        }
    }
    setPage(page) {
        // get new pager object for specified page
        this.pager = paginate(this.items.length, page, this.pageSize, this.maxPages);
        // get new page of items from items array
        var pageOfItems = this.items.slice(this.pager.startIndex, this.pager.endIndex + 1);
        // call change page function in parent component
        this.changePage.emit(pageOfItems);
    }
};
JwPaginationComponent.ɵfac = function JwPaginationComponent_Factory(t) { return new (t || JwPaginationComponent)(); };
JwPaginationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: JwPaginationComponent, selectors: [["jw-pagination"]], inputs: { initialPage: "initialPage", pageSize: "pageSize", maxPages: "maxPages", items: "items" }, outputs: { changePage: "changePage" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "pagination", 4, "ngIf"], [1, "pagination"], [1, "page-item", "first-item", 3, "ngClass"], [1, "page-link", 3, "click"], [1, "page-item", "previous-item", 3, "ngClass"], ["class", "page-item number-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "page-item", "next-item", 3, "ngClass"], [1, "page-item", "last-item", 3, "ngClass"], [1, "page-item", "number-item", 3, "ngClass"]], template: function JwPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, JwPaginationComponent_ul_0_Template, 14, 13, "ul", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.pager.pages && ctx.pager.pages.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf], encapsulation: 2 });
__decorate([
    Input()
], JwPaginationComponent.prototype, "items", void 0);
__decorate([
    Output()
], JwPaginationComponent.prototype, "changePage", void 0);
__decorate([
    Input()
], JwPaginationComponent.prototype, "initialPage", void 0);
__decorate([
    Input()
], JwPaginationComponent.prototype, "pageSize", void 0);
__decorate([
    Input()
], JwPaginationComponent.prototype, "maxPages", void 0);

let JwPaginationModule = class JwPaginationModule {
};
JwPaginationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: JwPaginationModule });
JwPaginationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function JwPaginationModule_Factory(t) { return new (t || JwPaginationModule)(); }, imports: [[CommonModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'jw-pagination',
                template: `<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
    <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item first-item">
        <a (click)="setPage(1)" class="page-link">First</a>
    </li>
    <li [ngClass]="{disabled:pager.currentPage === 1}" class="page-item previous-item">
        <a (click)="setPage(pager.currentPage - 1)" class="page-link">Previous</a>
    </li>
    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}" class="page-item number-item">
        <a (click)="setPage(page)" class="page-link">{{page}}</a>
    </li>
    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item next-item">
        <a (click)="setPage(pager.currentPage + 1)" class="page-link">Next</a>
    </li>
    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}" class="page-item last-item">
        <a (click)="setPage(pager.totalPages)" class="page-link">Last</a>
    </li>
</ul>`
            }]
    }], function () { return []; }, { changePage: [{
            type: Output
        }], initialPage: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], maxPages: [{
            type: Input
        }], items: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(JwPaginationModule, { declarations: function () { return [JwPaginationComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [JwPaginationComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwPaginationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [JwPaginationComponent],
                exports: [JwPaginationComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of jw-pagination
 */

/**
 * Generated bundle index. Do not edit.
 */

export { JwPaginationComponent, JwPaginationModule };

//# sourceMappingURL=jw-angular-pagination.js.map